const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410326200',
            ext_path: '河南省 洛阳市 汝阳县 柏树乡',
            cid: '1',
            pid: '410326',
            name: '柏树乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.385052, 34.160535]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326209',
            ext_path: '河南省 洛阳市 汝阳县 蔡店乡',
            cid: '2',
            pid: '410326',
            name: '蔡店乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.442144, 34.288773]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326100',
            ext_path: '河南省 洛阳市 汝阳县 城关镇',
            cid: '3',
            pid: '410326',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.468488, 34.177646]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326400',
            ext_path: '河南省 洛阳市 汝阳县 大安工业园区',
            cid: '4',
            pid: '410326',
            name: '大安工业园区',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.560199, 34.326213]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326102',
            ext_path: '河南省 洛阳市 汝阳县 付店镇',
            cid: '5',
            pid: '410326',
            name: '付店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.32814, 33.885813]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326203',
            ext_path: '河南省 洛阳市 汝阳县 靳村乡',
            cid: '6',
            pid: '410326',
            name: '靳村乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.283387, 33.952428]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326105',
            ext_path: '河南省 洛阳市 汝阳县 刘店镇',
            cid: '7',
            pid: '410326',
            name: '刘店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.556721, 34.092484]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326106',
            ext_path: '河南省 洛阳市 汝阳县 内埠镇',
            cid: '8',
            pid: '410326',
            name: '内埠镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.517948, 34.303618]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326104',
            ext_path: '河南省 洛阳市 汝阳县 三屯镇',
            cid: '9',
            pid: '410326',
            name: '三屯镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.486084, 34.028432]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326101',
            ext_path: '河南省 洛阳市 汝阳县 上店镇',
            cid: '10',
            pid: '410326',
            name: '上店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.434784, 34.098273]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326202',
            ext_path: '河南省 洛阳市 汝阳县 十八盘乡',
            cid: '11',
            pid: '410326',
            name: '十八盘乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.372368, 34.051189]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326107',
            ext_path: '河南省 洛阳市 汝阳县 陶营镇',
            cid: '12',
            pid: '410326',
            name: '陶营镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.51771, 34.248346]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326204',
            ext_path: '河南省 洛阳市 汝阳县 王坪乡',
            cid: '13',
            pid: '410326',
            name: '王坪乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.463072, 33.898873]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410326103',
            ext_path: '河南省 洛阳市 汝阳县 小店镇',
            cid: '14',
            pid: '410326',
            name: '小店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.561433, 34.167244]
        }
    }
];

export { d };
